<template>
  <div class="grid_table_holder">
    <table class="table_basic">
      <tbody>
        <tr>
          <th v-t="'CELL_BASELINE_BID'" scope="row" />
          <td>
            {{ bidTrace.BaselineBid }}
          </td>
        </tr>
        <tr>
          <th v-t="'CELL_ADJUSTMENTS'" scope="row" />
          <td>
            <span
              v-if="bidTrace.Adjustments && bidTrace.Adjustments.length > 0"
              class="clickable text-underline"
              @click="showAdjustments = !showAdjustments"
            >
              {{ $t('VIEW') }}
              <i class="fa fa-angle-right m-l-5" :class="{'fa-rotate-90': showAdjustments}" aria-hidden="true" />
            </span>
            <template v-else>{{ $t('N_A') }}</template>
          </td>
        </tr>
        <tr
          v-if="bidTrace.Adjustments && bidTrace.Adjustments.length > 0"
          class="hidden-row"
          :class="{'expanded': showAdjustments}"
        >
          <td colspan="2">
            <collapse v-model="showAdjustments">
              <div class="rtb-dashboard__rtb-log-detail-adjustments">
                <RtbAdjustment
                  v-for="(adjustment, index) in bidTrace.Adjustments"
                  :key="index"
                  :adjustment="adjustment"
                />
              </div>
            </collapse>
          </td>
        </tr>
        <tr v-if="bidTrace.FinalBid">
          <th v-t="'CELL_FINAL_BID'" scope="row" />
          <td>
            {{ bidTrace.FinalBid }}
          </td>
        </tr>
        <tr>
          <th v-t="'CELL_MAX_BID'" scope="row" />
          <td>
            {{ bidTrace.MaxBid }}
          </td>
        </tr>
        <tr>
          <th v-t="'CELL_MIN_DURATION_ADJUSTMENTS'" scope="row" />
          <td>
            <span
              v-if="bidTrace.MinDurationAdjustments && bidTrace.MinDurationAdjustments.length > 0"
              class="clickable text-underline"
              @click="showMinDurationAdjustments = !showMinDurationAdjustments"
            >
              {{ $t('VIEW') }}
              <i class="fa fa-angle-right m-l-5" :class="{'fa-rotate-90': showMinDurationAdjustments}" aria-hidden="true" />
            </span>
            <template v-else>{{ $t('N_A') }}</template>
          </td>
        </tr>
        <tr
          v-if="bidTrace.MinDurationAdjustments && bidTrace.MinDurationAdjustments.length > 0"
          class="hidden-row"
          :class="{'expanded': showMinDurationAdjustments}"
        >
          <td colspan="2">
            <collapse v-model="showMinDurationAdjustments">
              <div class="rtb-dashboard__rtb-log-detail-adjustments">
                <RtbAdjustment
                  v-for="(adjustment, index) in bidTrace.MinDurationAdjustments"
                  :key="index"
                  :adjustment="adjustment"
                />
              </div>
            </collapse>
          </td>
        </tr>
        <tr v-if="bidTrace.FinalMinDuration">
          <th v-t="'CELL_FINAL_MIN_DURATION'" scope="row" />
          <td>
            {{ bidTrace.FinalMinDuration }} sec
          </td>
        </tr>
        <tr v-if="hasOverridesObject">
          <th valign="top" v-t="'CELL_PUBLISHER_OVERRIDES'" scope="row" />
          <td>
            <ul v-if="hasOverrides" class="m-l-10">
              <li
                v-for="(override, index) in activeOverrides"
                :key="index"
              >
                {{ override }}
              </li>
            </ul>
            <template v-else>
              {{ $t('N_A') }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';

import RtbAdjustment from './RtbAdjustment';

export default {
  name: 'RtbBidTrace',
  components: {
    RtbAdjustment
  },
  props: {
    bidTrace: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      showAdjustments: false,
      showMinDurationAdjustments: false,
      activeOverrides: null,
      overridesMap: {
        
      },
      overridesMap: Object.freeze({
        OverrideRateLimitSettings: this.$t('OVERRIDE_RATE_LIMIT_SETTINGS'),
        OverrideDefaultBidSettings: this.$t('OVERRIDE_DEFAULT_BID_SETTINGS'),
        OverrideDefaultPassThroughSettings: this.$t('OVERRIDE_DEFAULT_PASS_THROUGH_SETTINGS'),
        OverrideBidAdjustments: this.$t('OVERRIDE_BID_ADJUSTMENTS'),
        OverrideCallerIdRequired: this.$t('OVERRIDE_CALLER_ID_REQUIRED'),
        OverrideBidExpirationPolicy: this.$t('OVERRIDE_BID_EXPIRATION_POLICY'),
        OverrideMinDurationAdjustment: this.$t('OVERRIDE_MIN_DURATION_ADJUSTMENT')
      }),
    }
  },
  mounted() {
    this.activeOverrides = this.getActiveOverrides(this.bidTrace.ActiveOverrides).map((key) => this.overridesMap[key]);
  },
  computed: {
    hasOverrides() {
      return this.activeOverrides && this.activeOverrides.length;
    },
    hasOverridesObject() {
      return this.bidTrace.ActiveOverrides;
    }
  },
  methods: {
    getActiveOverrides(obj) {
      let activeOverrides = [];

      for (let prop in obj) {
        if (obj.hasOwnProperty(prop) && obj[prop] === true) {
          activeOverrides.push(prop);
        }
      }

      return activeOverrides;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>